"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _Activate = _interopRequireDefault(require("./pages/Activate"));
var _Alerts = _interopRequireDefault(require("./pages/Alerts"));
var _clever = _interopRequireDefault(require("./pages/SSOError/clever.js"));
var _classlink = _interopRequireDefault(require("./pages/SSOError/classlink.js"));
var _Forgot = _interopRequireDefault(require("./pages/Forgot"));
var _ForgotUsername = _interopRequireDefault(require("./pages/ForgotUsername"));
var _Login = _interopRequireDefault(require("./pages/Login"));
var _Password = _interopRequireDefault(require("./pages/Password"));
var _Profile = _interopRequireDefault(require("./pages/Profile"));
var _RegistrationSurvey = _interopRequireDefault(require("./pages/RegistrationSurvey"));
var _Reset = _interopRequireDefault(require("./pages/Reset"));
var _SelfRoster = _interopRequireDefault(require("./pages/SelfRoster"));
var _Subscribe = _interopRequireDefault(require("./pages/Subscribe"));
var _Unsubscribe = _interopRequireDefault(require("./pages/Unsubscribe"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd && window.cccisd.fortress;
var Root = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Root() {
    _classCallCheck(this, Root);
    return _callSuper(this, Root, arguments);
  }
  _inherits(Root, _React$Component);
  return _createClass(Root, [{
    key: "render",
    value: function render() {
      var forgotUsername = (0, _get2["default"])(Fortress, 'settings.config.username.forgot_username', false);
      var _this$props = this.props,
        match = _this$props.match,
        defaultLayout = _this$props.defaultLayout,
        registrationSurveyLayout = _this$props.registrationSurveyLayout,
        _this$props$enableSel = _this$props.enableSelfRoster,
        enableSelfRoster = _this$props$enableSel === void 0 ? false : _this$props$enableSel,
        selfRosterProps = _this$props.selfRosterProps;
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/alerts"),
        component: _Alerts["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/login"),
        component: _Login["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/cleverError"),
        component: _clever["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/classlinkError"),
        component: _classlink["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/activate/:activationToken"),
        component: _Activate["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/reset/:resetToken"),
        component: _Reset["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/profile/:pawnId?/:pawnHash?"),
        component: _Profile["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/subscribe/:recipient/:hash"),
        component: _Subscribe["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/unsubscribe/:recipient/:hash"),
        component: _Unsubscribe["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/updatePassword/:pawnId?/:pawnHash?"),
        component: _Password["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/forgot"),
        component: _Forgot["default"],
        layout: defaultLayout
      }), forgotUsername && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/forgotUsername"),
        component: _ForgotUsername["default"],
        layout: defaultLayout
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        path: "".concat(match.url, "/registrationSurvey"),
        component: _RegistrationSurvey["default"],
        layout: registrationSurveyLayout
      }), enableSelfRoster && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.Route, {
        exact: true,
        path: "".concat(match.url, "/register/:hash"),
        component: _SelfRoster["default"],
        componentProps: selfRosterProps,
        layout: defaultLayout
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Root, "propTypes", {
  match: _propTypes["default"].object,
  /*
   *   To use below props via <AppRoute /> in routes.js,
   *   you may need to set layout={null} so that there
   *   is not a layout within a layout
   */
  defaultLayout: _propTypes["default"].func,
  // component
  registrationSurveyLayout: _propTypes["default"].func,
  // component
  enableSelfRoster: _propTypes["default"].bool,
  selfRosterProps: _propTypes["default"].object
});